import ShareTemplates from '../../pages/share_templates/ShareTemplates';
import ShowShareTemplate from '../../pages/share_templates/ShowShareTemplate';
import CreateShareTemplate from '../../pages/share_templates/CreateShareTemplate';
import CopyShareTemplateToTeam from '../../pages/share_templates/CopyShareTemplateToTeam';
import EditShareTemplate from '../../pages/share_templates/EditShareTemplate';
import DeleteShareTemplate from '../../pages/share_templates/DeleteShareTemplate';
import UnlayerTemplateEditor from '../../pages/unlayer/TemplateEditor';
import ShareTemplateAuditTrail from '../../pages/share_templates/ShareTemplateAuditTrail.vue';

export default [
  {
    path: '/v2/admin/email-templates',
    name: 'admin.share_templates.index',
    component: ShareTemplates,
    meta: {
      permission: 'can_edit_email_templates',
      title: 'Email Templates',
    },
  },
  {
    path: '/v2/admin/email-templates/create',
    name: 'admin.share_template.create',
    component: CreateShareTemplate,
    meta: {
      permission: 'can_edit_email_templates',
      title: 'New Email Template',
    },
  },
  { // MLD-3800
    path: '/v2/admin/email-templates/:templateID(\\d+)/copy-to-team',
    name: 'admin.share_template.copy_to_team',
    component: CopyShareTemplateToTeam,
    meta: {
      permission: 'can_edit_email_templates',
      title: 'Copy Email Template to another Team',
    },
  },
  {
    path: '/v2/admin/email-templates/:templateID(\\d+)',
    name: 'admin.share_template.show',
    component: ShowShareTemplate,
    meta: {
      permission: 'can_edit_email_templates',
      title: 'Template Performance',
    },
  },
  {
    path: '/v2/admin/email-templates/:templateID(\\d+)/edit',
    name: 'admin.share_template.edit',
    component: EditShareTemplate,
    meta: {
      permission: 'can_edit_email_templates',
      title: 'Edit Email Template',
    },
  },
  { // MLD-6709
    path: '/v2/admin/email-templates/:templateID(\\d+)/delete',
    name: 'admin.share_template.delete',
    component: DeleteShareTemplate,
    meta: {
      permission: 'can_edit_email_templates',
      title: 'Delete Email Template',
    },
  },
  { // MLD-2473
    path: '/v2/admin/email-templates/:templateID(\\d+)/unlayer/edit',
    name: 'admin.share_template.unlayer.edit',
    component: UnlayerTemplateEditor,
    meta: {
      permission: 'can_edit_email_templates',
    },
  },
  { // MLD-4769
    path: '/v2/admin/email-templates/:templateID(\\d+)/audit-trail',
    name: 'admin.share_template.audit_trail',
    component: ShareTemplateAuditTrail,
    meta: {
      permission: 'can_edit_email_templates',
    },
  },
]
